<template>
  <v-card
    class="trip-card"
    :style="{ color: textColor }"
    :to="{ name: 'trip', params: { id: trip.id } }"
  >
    <v-img
      :src="trip.image ? trip.image : require('@/assets/images/trip-placeholder.jpg')"
      height="125px"
      cover
    >
      <v-container
        fill-height
        class="justify-center"
      >
        <v-row justify="center">
          <v-col
            align-self="center"
            class="text-center"
          >
            <div class="trip-name display-1 text-truncate text-center">
              <div
                class="trip-name__highlighter"
                :style="highlighterStyle"
              />

              <div class="trip-name__text">
                {{ trip.name }}
              </div>
            </div>
          </v-col>
        </v-row>

        <div
          v-if="trip.$.startDate"
          class="trip-card__footer"
        >
          <div class="trip-card__footer__dates">
            {{ trip.$.startDate | fmtDateInterval(trip.$.endDate) }}
          </div>

          <v-flex />

          <div
            v-if="creator"
            class="trip-card__footer__creator"
          >
            <v-tooltip left>
              <template #activator="{ on }">
                <v-avatar
                  :size="30"
                  v-on="on"
                >
                  <img
                    v-if="creator.photoURL"
                    :src="creator.photoURL"
                  >

                  <span v-else>{{ (creator.displayName || creator.email)[0] }}</span>
                </v-avatar>
              </template>

              <span>
                Created by
                {{ creator.displayName || creator.email }}
              </span>
            </v-tooltip>
          </div>
        </div>
      </v-container>
    </v-img>
  </v-card>
</template>

<script>
import { firestore } from '@/plugins/firebase'

export default {
  props: {
    trip: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      creator: null,
      defaultBackgroundColor: '#bba87f',
      defaultTextColor: 'white'
    }
  },
  computed: {
    textColor () {
      return this.trip.textColor || this.defaultTextColor
    },
    highlighterStyle () {
      return {
        backgroundColor: this.trip.backgroundColor || this.defaultBackgroundColor,
        transform: `rotate(${Math.random() * 6 - 3}deg)`, // rotate between +/-2 degs
        width: `${100 - Math.random() * 20}%`, // width between 80 and 100%
        left: `${Math.random() * 10}px`
      }
    }
  },
  async mounted () {
    if (this.trip.createdBy !== this.$currentUser.id) {
      const doc = await firestore
        .collection('users')
        .doc(this.trip.createdBy)
        .get()

      this.creator = doc.data()
    }
  }
}
</script>

<style lang="scss">
.trip-card {
  overflow: hidden;
  border-radius: 20px !important;

  .trip-name {
    position: relative;
    display: inline-block;
    padding: 0 20px 0 10px;

    &__text {
      position: relative;
      z-index: 1;
    }

    &__highlighter {
      position: absolute;
      z-index: 0;
      height: 70%;
      width: 100%;
      bottom: 0;
      left: 0;
      opacity: 0.7;
    }
  }

  &__footer {
    display: flex;
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;

    &__dates {
      background: radial-gradient(at bottom left, #a5a5a5, transparent 80%);
      line-height: 38px;
      padding-left: 16px;
    }

    &__creator {
      margin-right: 16px;
      margin-bottom: 8px;
    }
  }
}
</style>
